import * as type from '@app/constants/myDevices/deviceSettings/deviceColours'
import { IDeviceColoursData } from '@app/@types/myDevices'

export const postDeviceColour = (id: number, data: IDeviceColoursData) => ({
  type: type.POST_DEVICE_COLOURS,
  id,
  data,
} as const)
